import { BadgeCheck, Smartphone, ExternalLink } from "lucide-react";

export const LOCALLY_AI_URL = "https://apps.apple.com/app/locally-ai-private-ai-chat/id6741426692";

export function FreeBanner() {
  return (
    <div className="flex gap-3 rounded-xl border border-emerald-800/60 bg-emerald-950/20 p-4" data-testid="assistant-free-banner">
      <BadgeCheck className="h-5 w-5 shrink-0 text-emerald-400" />
      <div className="text-sm">
        <div className="font-medium text-emerald-200">100 % gratuit et local : aucune clé, aucun abonnement</div>
        <p className="mt-1 text-xs text-emerald-100/80">
          Vos questions ne quittent jamais votre appareil. Trois façons de l'utiliser : l'IA qui tourne directement dans ce navigateur,
          votre propre Ollama / LM Studio installé sur l'ordinateur, ou le questionnaire guidé sans IA.
        </p>
      </div>
    </div>
  );
}

export function LocallyAiCard() {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-[#1E2638] bg-[#0F141C] p-4" data-testid="locally-ai-card">
      <Smartphone className="h-6 w-6 shrink-0 text-primary" />
      <div className="min-w-0 flex-1 text-sm">
        <div className="font-medium text-slate-200">Sur iPhone ou iPad ? Installez Locally AI</div>
        <p className="mt-0.5 text-xs text-muted-foreground">
          App gratuite (par LM Studio) qui fait tourner Llama, Qwen ou Gemma hors ligne, optimisée pour les puces Apple. Ouvrez l'app, choisissez un modèle dans « Manage Models » et discutez.
        </p>
      </div>
      <a href={LOCALLY_AI_URL} target="_blank" rel="noopener noreferrer" data-testid="locally-ai-link"
        className="inline-flex items-center gap-1.5 rounded-md bg-primary px-3 py-2 text-xs font-semibold text-primary-foreground hover:bg-primary/90">
        App Store <ExternalLink className="h-3.5 w-3.5" />
      </a>
    </div>
  );
}
